import React from "react";
import styles from "./CoreValues.module.css";
import {
  FaUsers,
  FaHandsHolding,
  FaEarthAmericas,
  FaFaceSmile,
  FaLightbulb,
  FaGears,
} from "react-icons/fa6";

const CoreValues = () => {
  const values = [
    {
      icon: <FaUsers />,
      title: "Teamwork",
      description: "We are stronger when we work together",
    },
    {
      icon: <FaHandsHolding />,
      title: "Inclusion",
      description: "We respect each other and embrace our differences",
    },
    {
      icon: <FaEarthAmericas />,
      title: "Impact",
      description: "We apply what we learn to improve our world",
    },
    {
      icon: <FaFaceSmile />,
      title: "Fun",
      description: "We enjoy and celebrate what we do",
    },
    {
      icon: <FaLightbulb />,
      title: "Discovery",
      description: "We explore new skills and ideas",
    },
    {
      icon: <FaGears />,
      title: "Innovation",
      description: "We use creativity and persistence to solve problems",
    },
  ];

  return (
    <div className={styles.coreValuesBG}>
      <div className={styles.coreValues}>
        <div className={styles.header}>
          <h2>IRL CORE VALUES</h2>
          <h3>Core Values in a Nutshell...!</h3>
          <p>
            Respecting each other and accepting differences, discovering new
            talents and ideas, working creatively and persistently, applying and
            improving what you have learned, working together and having fun at
            work are among the core values of INDIA ROBOTICS LEAGUE Challenge
            and make a good team.
          </p>
        </div>
        <div className={styles.valuesGrid}>
          {values.map((value, index) => (
            <div key={index} className={styles.valueCard}>
              <div className={styles.iconWrapper}>{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoreValues;
